import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ConfigProvider, theme, App } from "antd";
import { routeTree } from "./routeTree.gen";

const queryClient = new QueryClient();
const router = createRouter({ routeTree });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ConfigProvider
        theme={{
          algorithm: theme.darkAlgorithm,
          components: {
            // The dark-theme off-state Switch track (colorTextQuaternary) is too
            // faint and blends into the background — make the unchecked/off toggle
            // clearly visible. colorTextTertiary is the off-track hover color.
            Switch: {
              colorTextQuaternary: "#5a6169", // off track — solid gray, clearly visible on the dark bg
              colorTextTertiary: "#727a83", // off track on hover
            },
          },
        }}
      >
        <App>
          <RouterProvider router={router} />
        </App>
      </ConfigProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
